import { Key, TruckTrailer } from '@phosphor-icons/react';
import { useState } from 'react';
import { CASH_ADVANCE_LOCKED_COPY } from '../../../../../../constants/bankingCopy';
import RentalRequestModal from '../../resources/RentalRequestModal';
import HomeActionCard from './HomeActionCard';

// Rentals V1 — Web. A second entry point for the rental request, beside Find Me
// Freight on CustomerHome; the first is RentalRequestCard on My Resources. Both
// open the same RentalRequestModal.
//
// No NEW badge: that marks Find Me Freight as the headline action.
//
// Hidden for pre-active/demo accounts, matching Find Me Freight — the request
// reaches a real TACH rep, and My Resources (the other entry) is unreachable
// until the account is active.
//
// Locked (shown, CTA disabled) for as long as cash advance is: a rental is
// credit-like, and the rep's first check is whether the carrier has been
// depositing — the same rule that unlocks cash advance.

interface RequestRentalEntryProps {
  isPreActive: boolean;
  isCashAdvanceLocked: boolean;
}

const RequestRentalEntry = ({
  isPreActive,
  isCashAdvanceLocked,
}: RequestRentalEntryProps) => {
  const [isOpen, setIsOpen] = useState(false);

  if (isPreActive) return null;

  return (
    <>
      <HomeActionCard
        testIdPrefix="requestRental"
        icon={<TruckTrailer size={18} className="text-primary" />}
        title="Request a Rental"
        subtitle="Need a truck or trailer? We'll set it up for you."
        ctaIcon={<Key size={16} weight="fill" />}
        ctaLabel="Request a Rental"
        onClick={() => setIsOpen(true)}
        lockedReason={
          isCashAdvanceLocked ? CASH_ADVANCE_LOCKED_COPY : undefined
        }
      />

      {/* Mounted only while open, so each open is a fresh form — same reason
          as RentalRequestCard: a late POST resolve must not write into the
          next open. */}
      {isOpen && (
        <RentalRequestModal isOpen={isOpen} onClose={() => setIsOpen(false)} />
      )}
    </>
  );
};

export default RequestRentalEntry;
